module.exports = __webpack_public_path__ + "static/media/noImageXS.8bcbecff.jpg";